import React, { useState, useEffect } from "react";
import { database } from "../../database/firebase";
import { Header } from "../../components";
import CatchCard from '../../components/CatchCard';
import { useHistory } from "react-router-dom";

function NewCatch() {
  //console.log("NewCatch");
  // const [user, setUser] = useState({});
  const [fisherInfo, setFisherInfo] = useState({});
  const [newCatchInfo, setNewCatchInfo] = useState({});
  const [catchTime, setCatchTime] = useState({ date: "", time: "" });
  // const [click, setClick] = useState("false");
  const history = useHistory();
  useEffect(() => {
    const fetchCatch = async () => {
      let uid = localStorage.getItem("uid");
      if (uid) {
        let userUid = JSON.parse(uid);
        // database.child(`users/${userUid}`).once("value", (snap) => {
        //   let data = snap.val();
        //   setUser(data);
        // });

        database.child(`users/${userUid}/catch/`).orderByChild('timestamp').limitToLast(1).on("child_added", (snap) => {
          let catchData = snap.val();
          setNewCatchInfo(catchData);

          // let date = new Date(catchData.timestamp * 1000);
          let date = new Date(catchData.timestamp);
          var year = date.getFullYear();
          var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
          var month = months[date.getMonth()];
          var day = date.getDate();
          var hours = date.getHours();
          var minutes = "0" + date.getMinutes();
          var seconds = "0" + date.getSeconds();
          var time = hours + ':' + minutes.substr(-2) + ':' + seconds.substr(-2);
          var timedate = month + " " + day + ", " + year;
          setCatchTime({ date: timedate, time: time });

          database.child(`users/${userUid}/userfisher/${catchData.fisherUid}`).once("value", (snap) => {
            let fisherData = snap.val();
            setFisherInfo(fisherData);
          });
        });
      };

    };
    fetchCatch();

    return () => {
      if (history.action === "POP" && localStorage.getItem("uid")) {
        // Code here will run when back button fires. Note that it's after the `return` for useEffect's callback; code before the return will fire after the page mounts, code after when it is about to unmount.        history.push("newcatch");
      }

    }
  }, [history, history.action]);



  //insert geocoding

  return (
    <div className="md:flex">
      <aside class="md:h-screen md:sticky md:top-0">
        <Header />
      </aside>
      <div className="flex flex-col w-full">
        <div className="flex text-4xl mt-20 text-blue-700 font-sans font-bold h-14 md:ml-20">
          New Seafood Catch Data
        </div>
        <div className="bg-blue-600 h-0.5"></div>

        <div className="mx-auto">
          <div className="flex mt-10">
            {newCatchInfo && fisherInfo ?
              <div>
                <CatchCard
                  newCatchInfo={newCatchInfo}
                  catchTime={catchTime}
                  fisherInfo={fisherInfo}
                />
              </div>
              :
              <div className="mb-5 rounded-3xl bg-white shadow-2xl sm:p-10">
                <p className="text-center font-sans text-2xl"> No data or fisherman record is deleted. </p>
              </div>
            }
          </div>
        </div>

      </div>
    </div>

  );
}

export default NewCatch;